import { Link } from "react-router-dom";

type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  desc?: string;
  moreTo?: string;
  moreLabel?: string;
};

export default function SectionHeading({ eyebrow, title, desc, moreTo, moreLabel }: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-6">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs font-bold tracking-wide text-accent-700 mb-2">
            <span className="w-4 h-[2px] bg-accent-500 inline-block"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">{title}</h2>
        {desc && <p className="mt-2 text-sm text-foreground-600 max-w-2xl leading-relaxed">{desc}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-800 transition-colors cursor-pointer whitespace-nowrap shrink-0"
        >
          {moreLabel ?? "查看全部"}
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}